import React, { useEffect, useState, useCallback } from 'react';
// import DataTable from '@/containers/data_table_ml/DataTable';
import { Box } from '@material-ui/core';
import DataTableNativeML from '@/components/DataTableNativeML';
import { useDispatch, useSelector } from 'dva';
import dayjs from 'dayjs';
import ModalML from '@/components/ModalML';
import { useIntl } from 'umi';
import ConsumptionRecordDetail from '../detail_components/CodeDetail.js';
import { optionToKey, fmtThousand } from '@/utils/comUtil.js';
import { channelMap } from '@/constants.js';

const IntegralHistory = (props) => {
  //国际化
  const intl = useIntl();
  const { formatMessage } = intl;
  const { params = {} } = props || {};
  const { id } = params || {};
  const [pageData, setPageData] = useState({
    pageSize: 10,
    pageNum: 1,
  });
  const handleDetail = (s) => {
    dispatch({
      type: 'orderDetail/getOrderDetail',
      payload: {
        values: {
          id: s.orderId,
        },
      },
    });
    setOpen(true);
  };

  const columns = [
    {
      title: formatMessage({ id: 'cm.member.detail.c03.lbl01' }),
      key: 'changeDate',
      id: 'changeDate',
      align: 'center',
      width: 200,
      render: ({ changeDate: text }) =>
        text ? dayjs(text).format('YYYY-MM-DD HH:mm:ss') : '-',
    },
    {
      title: formatMessage({ id: 'cm.member.detail.c03.lbl02' }),
      key: 'effectiveDate',
      id: 'effectiveDate',
      align: 'center',
      width: 200,
      render: ({ effectiveDate: text }) =>
        text ? dayjs(text).format('YYYY-MM-DD HH:mm:ss') : '-',
    },
    {
      title: formatMessage({ id: 'cm.member.detail.c03.lbl03' }),
      id: 'expireDate',
      key: 'expireDate',
      align: 'center',
      width: 200,
      render: ({ expireDate: text }) =>
        text ? dayjs(text).format('YYYY-MM-DD HH:mm:ss') : '-',
    },
    {
      title: formatMessage({ id: 'cm.member.detail.c03.lbl04' }),
      width: 200,
      // width: 300,
      align: 'center',
      id: 'remark',
      key: 'remark',
    },
    {
      title: formatMessage({ id: 'cm.member.detail.c03.lbl05' }),
      id: 'orderNo',
      width: 256,
      align: 'center',
      key: 'orderNo',
      render: (record) => {
        return !record.orderNo ? (
          <span>-</span>
        ) : (
          <span
            style={{ color: '#1c78c8', cursor: 'pointer' }}
            onClick={() => handleDetail(record)}
          >
            {record.orderNo}
          </span>
        );
      },
    },
    {
      title: formatMessage({ id: 'cm.member.detail.c03.lbl06' }),
      key: 'channel',
      id: 'channel',
      align: 'center',
      render: ({ channel: text }) => {
        let grade = '';
        grade = optionToKey(channelMap, text);
        return grade || '-';
      },
    },
    {
      title: formatMessage({ id: 'cm.member.detail.c03.lbl07' }),
      width: 140,
      id: 'point',
      key: 'point',
      align: 'center',
      render: ({ point: text }) =>
        text || text === 0 ? fmtThousand(text, 0) : '-',
    },
    {
      title: formatMessage({ id: 'cm.member.detail.c03.lbl08' }),
      width: 140,
      key: 'leftPoint',
      id: 'leftPoint',
      align: 'center',
      render: ({ leftPoint: text }) =>
        text || text === 0 ? fmtThousand(text, 0) : '-',
    },
    {
      title: formatMessage({ id: 'cm.member.detail.c03.lbl09' }),
      // width: 140,
      key: 'createBy',
      id: 'createBy',
      align: 'center',
      render: ({ createBy }) => (createBy ? createBy : '--'),
    },
  ];
  const dispatch = useDispatch();

  const loadingEffect = useSelector((state) => state.loading);
  const loading = loadingEffect.effects['ml/getIntegralHistory'];
  const HistoryData = useSelector((state) => state.ml.getIntegralHistory);
  const { orderData } = useSelector((state) => state.orderDetail) || {};
  const { total, data: dataList = [{ code: '18' }] } = HistoryData || {};
  // 发起请求
  const setUseCallback = useCallback(() => {
    if (id) {
      dispatch({
        type: 'ml/getIntegralHistory',
        payload: {
          values: {
            limit: pageData.pageSize,
            page: pageData.pageNum,
            member_id: id,
          },
        },
      });
    }
  }, [dispatch, id, pageData.pageSize, pageData.pageNum]);
  useEffect(() => {
    setUseCallback();
  }, [setUseCallback]);
  const [open, setOpen] = useState(false);
  const handleCancel = () => {
    setOpen(false);
  };

  return (
    <Box style={{ height: '100%' }}>
      <DataTableNativeML
        loading={loading}
        // pageButton={false}
        paging={false}
        total={total}
        // title="会员列表"
        columns={columns}
        page={{
          ...pageData,
          total: total,
        }}
        // buttonTitle={[{ text: '新增', onClick: edit }]}
        changePage={(pageObj) => {
          setPageData(pageObj);
        }}
        data={dataList}
        columnKey="id"
      ></DataTableNativeML>
      {/* <DataTable
        className="demo-test"
        columns={columns}
        rowSelection={false}
        pagination={{
          pageSize: limit,
          total: total,
          page: page,
        }}
        scroll={{ y: 'calc(100vh - 300px - 3.5rem)' }}
        dataSource={dataList}
        changePage={({ current }) => {
          setPage(current);
        }}
        changePageSize={(val) => {
          setLimit(val);
          setPage(1);
        }}
        loading={loading}
      /> */}

      {/* <IntegralHistoryForm ref={formRef} />
      <IntegralHistoryAddForm ref={formaddRef} /> */}
      <ModalML
        open={open}
        onClose={handleCancel}
        title={formatMessage({ id: 'cm.member.detail.d03.lbl01' })}
        isHasBcg={false}
      >
        <ConsumptionRecordDetail
          detail={{ ...orderData, orderItemList: orderData.orderItems }}
        />
      </ModalML>
    </Box>
  );
};
export default IntegralHistory;
